import { useEffect, useState } from "react";
import HorizontalBarChart from "./HorizontalBarChart";
import VerticalStackedBarChart from "./VerticalStackedBarChart";

const PivotableBarChart = ({ title, usages, groupBy, countBy, isLogarithm = false, vertical = false, xAxisLabel, yAxisLabel, titleFontWeight, showTitleDivider }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const grouped = {};

    usages.forEach((u) => {
      const key = `${u[groupBy]}`;
      if (!grouped[key]) grouped[key] = 0;
      grouped[key] += u[countBy];
    });
    const chartData = Object.entries(grouped)
      .map(([label, value]) => ({ label, value: Math.round(value * 100) / 100 }))
      .sort((a, b) => b.value - a.value);

    setData(chartData);
  }, [usages, groupBy, countBy]);
  return (
    <HorizontalBarChart
      title={title}
      data={data}
      isLogarithm={isLogarithm}
      xAxisLabel={xAxisLabel}
      yAxisLabel={yAxisLabel}
      titleFontWeight={titleFontWeight}
      showTitleDivider={showTitleDivider}
    />
  );
};

export default PivotableBarChart;
